import type { CareScene } from '../types';
import { CollapsibleItems } from './Expandable';
import styles from '../App.module.css';

interface CareScenesProps {
  items: CareScene[];
}

export function CareScenes({ items }: CareScenesProps) {
  return (
    <CollapsibleItems total={items.length} initial={2}>
      {(visible) => (
        <div className={styles.scenesGrid}>
          {items.slice(0, visible).map((scene) => (
            <div key={scene.id} className={styles.sceneCard}>
              <h4 className={styles.sceneTitle}>{scene.title}</h4>
              <ul className={styles.sceneList}>
                {scene.items.map((s, i) => (
                  <li key={i} className={styles.sceneItem}>
                    {s}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}
    </CollapsibleItems>
  );
}
